import CallLogTableView from './CallLogTable'

export const CallLogTable = CallLogTableView

export default CallLogTableView
